import React from 'react'
import { FinancingProductSuccess } from '@/components/composed/financing/FinancingProductSuccess'
import type { TFinancingRequestStepperSuccessComponentProps } from '@/components/composed/financing/FinancingRequestStepper/types'
import { NAV_SUCCESS_NEW_ITEMS } from '@/pages/FinancingAgent/constants'
import { messages } from '../../messages'
import { FinancingConsultingWrapper } from '../FinancingConsultingWrapper'
import './styles.scss'

export const FinancingConsultingSuccess = ({ state, onResetForm }: TFinancingRequestStepperSuccessComponentProps<{}>) => (
  <FinancingConsultingWrapper isFollowingStep>
    <FinancingProductSuccess
      className="financingConsultingSuccess"
      wrapperClassName="financingConsultingSuccess__wrapper"
      subtitleClassName="financingConsultingSuccess__subtitle"
      titleClassName="financingConsultingSuccess__title"
      itemClassName="financingConsultingSuccess__item"
      navClassName="financingConsultingSuccess__nav"
      navIconClassName="financingConsultingSuccess__navIcon"
      subtitle={messages.success.subtitle}
      navItems={NAV_SUCCESS_NEW_ITEMS}
      resetStep={onResetForm}
      fundingRequestId={state.fundingRequestId}
    />
  </FinancingConsultingWrapper>
)
